export enum REGISTRATION_STEPS {
  NONE = "None",
  //ACCOUNT REGISTRATION
  ACCOUNT_CREATION = "Registracija",
  QUESTIONAIRE = "Klausimynas",
  //PRODUCT REGISTRATION
  MEDNET_REG = "mednet_registration",
  CALENDLY_REG = "klavio_registration",
  VO2MAX_CALENDLY_REG = "vo2max",
  DONE = "done",

  //     [
  //     "type_form",
  //     "klavio_registration"
  // ]
}

export type RegistrationStepType = `${REGISTRATION_STEPS}`;
